// frontend/src/services/PaymentService.js
import apiClient from '@/services/api';
import { useAuthStore } from '@/stores/auth';
import OccupancyService from '@/services/OccupancyService';

const API_URL = '/payments';

const sanitizePaymentData = (paymentData) => {
  const data = { ...paymentData };
  const authStore = useAuthStore();

  data.company_id = authStore.currentUser?.company_id;
  // data.occupancy_id = fetchTenantAndUnitOccupancy(data.tenant_id, data.unit_id);

  // console.log("data.company_id:", data.company_id);

  if (data.unit_id) data.unit_id = Number(data.unit_id);
  if (data.tenant_id) data.tenant_id = Number(data.tenant_id);
  if (data.occupancy_id) data.occupancy_id = Number(data.occupancy_id); else data.occupancy_id = null;
  if (data.amount_paid) data.amount_paid = Number(data.amount_paid);
  if (!data.reference_number) data.reference_number = 'N/A';
  if (!data.invoice_id) data.invoice_id = 'N/A';

  const formatDate = (date) => {
    if (!date) return null;
    if (date instanceof Date) return date.toISOString().split('T')[0];
    return date;
  };
  data.payment_date = formatDate(data.payment_date);
  return data;
};

export default {
  fetchTenantAndUnitOccupancy: async (tenant_id, unit_id) => {
    const allOccs = await OccupancyService.getOccupancies(); 
    const occupancy = allOccs.find(o => o.tenant_id === tenant_id && o.unit_id === unit_id);
    // return occupancy?.id;
    return occupancy ? occupancy.id : null;
  },

  async fetchTenantsUnit(tenant_id) {
    const allOccs = await OccupancyService.getOccupancies(); 
    const occupancy = allOccs.find(o => o.tenant_id === tenant_id);
    return occupancy ? { id: occupancy.unit_id, name: occupancy.unit_name } : null;
  },

  async getPayments() {
    const authStore = useAuthStore();
    const userCompanyId = authStore.currentUser?.company_id;
    let url = API_URL;
    if (userCompanyId) {
      const filter = {"field":"company_id","value":userCompanyId};
      url += `?filter=${encodeURIComponent(JSON.stringify(filter))}`;
    }
    const response = (await apiClient.get(url));
    return response.data;
  },
  async getPayment(id) {
    const response = (await apiClient.get(`${API_URL}/${id}`));
    return response.data;
  },
  async createPayment(paymentData) {
    const response = (await apiClient.post(API_URL, sanitizePaymentData(paymentData)));
    return response.data;
  },
  async updatePayment(id, paymentData) {
    const response = (await apiClient.put(`${API_URL}/${id}`, sanitizePaymentData(paymentData)));
    return response.data;
  },
  async deletePayment(id) {
    return (await apiClient.delete(`${API_URL}/${id}`));
  }
};